import { Link } from 'react-router-dom';

const TIER_STYLES: Record<string, string> = {
  'Everyday': 'bg-[#F2C612] text-[#1A1A1A]',
  'Contractor Grade': 'bg-[#2D7AC2] text-white',
  'Elite Pro': 'bg-[#D42B2B] text-white',
};

export default function ProductCategories() {
  const categories = [
    {
      name: 'Tile Adhesive',
      description: 'Superior bonding strength for all tile types and surfaces. Available in Everyday, Contractor Grade, and Elite Pro formulations.',
      image: 'https://static.readdy.ai/image/783dd8c3d2d1f38f9648f46144ac17f1/e5d9afd00fd9a5d6b1108c8772c59acb.png',
      tiers: ['Everyday', 'Contractor Grade', 'Elite Pro'],
      link: '/products/tile-adhesive',
    },
    {
      name: 'Grout',
      description: 'Professional-grade grout solutions for lasting tile installations. Choose from three performance levels to match your project needs.',
      image: 'https://static.readdy.ai/image/783dd8c3d2d1f38f9648f46144ac17f1/48a33e494ab59672b788372208818b2e.png',
      tiers: ['Everyday', 'Contractor Grade', 'Elite Pro'],
      link: '/products/grout',
    },
    {
      name: 'Paint & Coatings',
      description: 'Premium paint and protective coatings for interior and exterior applications. Three tiers for every budget and performance requirement.',
      image: 'https://static.readdy.ai/image/783dd8c3d2d1f38f9648f46144ac17f1/65ad714713375d898c35137567a89d53.png',
      tiers: ['Everyday', 'Contractor Grade', 'Elite Pro'],
      link: '/products/paint',
    },
    {
      name: 'Bonding Liquid',
      description: 'High-performance bonding liquid additives that enhance adhesion, flexibility, and durability. Available in Everyday, Contractor Grade, and Elite Pro formulations for every application.',
      image: 'https://static.readdy.ai/image/783dd8c3d2d1f38f9648f46144ac17f1/914a93f1b74950a0a4bd957edfaf0597.png',
      tiers: ['Everyday', 'Contractor Grade', 'Elite Pro'],
      link: '/products/bonding-liquid',
    },
  ];

  return (
    <section className="py-16 md:py-20 px-4 md:px-8 bg-white overflow-x-hidden">
      <div className="max-w-7xl mx-auto">
        <div className="space-y-12 md:space-y-20">
          {categories.map((category, index) => (
            <div
              key={category.name}
              className={`flex flex-col ${
                index % 2 === 0 ? 'md:flex-row' : 'md:flex-row-reverse'
              } gap-6 md:gap-12 items-center`}
            >
              <div className="w-full md:w-1/2">
                <div className="aspect-[3/2] rounded-lg overflow-hidden">
                  <img
                    src={category.image}
                    alt={category.name}
                    className="w-full h-full object-cover"
                  />
                </div>
              </div>
              <div className="w-full md:w-1/2">
                <h3 className="font-['Montserrat'] font-bold text-2xl md:text-3xl mb-4 text-[#1A1A1A]">
                  {category.name}
                </h3>
                <p className="text-base md:text-lg text-gray-600 mb-6">
                  {category.description}
                </p>
                <div className="flex flex-wrap gap-2 mb-6">
                  {category.tiers.map((tier) => (
                    <span
                      key={tier}
                      className={`px-3 py-1 text-xs md:text-sm font-medium rounded-full ${TIER_STYLES[tier] ?? 'bg-gray-100 text-gray-700'}`}
                    >
                      {tier}
                    </span>
                  ))}
                </div>
                <Link
                  to={category.link}
                  className="flex items-center justify-center w-full md:w-auto md:inline-flex bg-[#F2C612] text-[#1A1A1A] font-['Montserrat'] font-semibold px-8 py-3 rounded-lg hover:bg-[#d4ad0a] transition-colors text-center whitespace-nowrap cursor-pointer min-h-[48px]"
                >
                  View {category.name}
                </Link>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
